import { Routes } from "@ctypes";

export const AUTH_PATHS = [
  Routes.Auth,
  Routes.GetStarted,
  Routes.EntryName,
  Routes.EntryPreferredName,
  Routes.EntryGreeting,
  Routes.EntryEmail,
  Routes.EntryPhone,
  Routes.Login,
  Routes.SignUp,
  Routes.EmailLogin,
  Routes.PhoneLoginInput,
  Routes.PhoneLoginVerification,
  Routes.EmailCodeVerification,
  Routes.PartnerExistingAccount,
  Routes.ForgotPassword,
  Routes.ForgotPasswordConfirmation,
];

export const ONBOARDING_PATHS = [
  // Also in AUTH_PATHS. The get-started journey runs these before login; a phone-first signup,
  // which registers from the login screen, runs the same screens after it. Membership in both
  // sets is what lets each flow own them: a provider only exits to the router for a step outside
  // its own set, so the pre-auth journey still walks these internally at /auth.
  Routes.GetStarted,
  Routes.EntryName,
  Routes.EntryPreferredName,
  Routes.EntryGreeting,
  Routes.EntryEmail,
  Routes.Email,
  Routes.PhoneNumber,
  Routes.PhoneVerification,
  Routes.Name,
  Routes.AddBeneficiaryType,
  Routes.AddChild,
  Routes.GoalType,
  Routes.TaxFlexibility,
  Routes.GoalName,
  Routes.TrumpAccountCheck,
  Routes.TrumpAccountSetup,
  Routes.TrumpSidecarIntroduction,
  Routes.TrumpSidecarCurrentContribution,
  Routes.TrumpSidecarTaxCalculation,
  Routes.TrumpSidecarRecommendedContribution,
  Routes.GoalDeposit,
  Routes.ChildDeposit,
  Routes.InvestmentPriority,
  Routes.InvestmentDownturnReaction,
  Routes.AccountType,
  Routes.AccountHorizon,
  Routes.DateOfBirth,
  Routes.ResidentialAddress,
  Routes.ResidentialAddressConfirmation,
  Routes.Citizenship,
  Routes.Ssn,
  Routes.TaxGainHarvest,
  Routes.BeneficiarySsn,
  Routes.SecureAccountIntro,
  Routes.BankLinking,
  Routes.InsufficientBankBalance,
  Routes.UnsupportedBank,
  Routes.MaritalStatus,
  Routes.ReviewProfile,
  Routes.Prefill,
  Routes.Employment,
  Routes.EmployerAddress,
  Routes.EmployerAddressAutofill,
  Routes.EmployerAddressConfirmation,
  Routes.AssetsRange,
  Routes.OnboardingComplete,
];

export const ENTRY_PATHS = [...AUTH_PATHS, ...ONBOARDING_PATHS];

export const AUTH_STEPS = new Set<string>(AUTH_PATHS);
export const ONBOARDING_STEPS = new Set<string>(ONBOARDING_PATHS);
export const ENTRY_STEPS = new Set<string>(ENTRY_PATHS);

export const BACK_TARGET: Partial<Record<string, string>> = {
  [Routes.GetStarted]: Routes.Auth,
  [Routes.EntryName]: Routes.GetStarted,
  [Routes.EntryPreferredName]: Routes.EntryName,
  [Routes.EntryEmail]: Routes.EntryPreferredName,
  [Routes.EntryPhone]: Routes.EntryEmail,
  [Routes.Login]: Routes.Auth,
};

export const BACK_HISTORY = new Set<string>([
  Routes.SignUp,
  Routes.EmailLogin,
  Routes.PhoneLoginInput,
  Routes.PhoneLoginVerification,
  Routes.EmailCodeVerification,
  Routes.ForgotPassword,
  Routes.AddChild,
  Routes.GoalType,
  Routes.GoalName,
  Routes.TaxFlexibility,
  Routes.AccountType,
  Routes.AccountHorizon,
  Routes.MaritalStatus,
  Routes.BeneficiarySsn,
  Routes.TaxGainHarvest,
  Routes.GoalDeposit,
  Routes.ChildDeposit,
  Routes.BankLinking,
]);
